import React from 'react'
import { useTranslate } from '@/utils/translate/translate-client'
import { HlsTooltip } from './HlsTooltip'

/** Audio tracks icon — Bitmovin audio-tracks.svg (32x32 viewBox, speech bubble with speaker). */
const AudioTracksIcon: React.FC = () => (
  <svg width={24} height={24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="#fff"
      d="M15.91 18.82a.62.62 0 01-.35.56.61.61 0 01-.65-.09L11.59 16.5H9.81a.6.6 0 01-.6-.6V13.47a.62.62 0 01.6-.62h1.78l3.32-2.79a.63.63 0 01.87.1.65.65 0 01.13.38zm2.34-.93H18.2a.64.64 0 01-.43-.18l-.08-.08a.6.6 0 01-.06-.79 3.54 3.54 0 00-.09-4.33.61.61 0 010-.82l.08-.08a.61.61 0 01.46-.18.67.67 0 01.45.22 4.89 4.89 0 01.13 6 .61.61 0 01-.45.24zm2.51 1.86a.58.58 0 01-.44.21h0a.63.63 0 01-.43-.17l-.08-.09a.61.61 0 010-.82 6.5 6.5 0 00-.1-8.46.6.6 0 010-.83V9.5a.56.56 0 01.44-.17.57.57 0 01.44.2 7.8 7.8 0 01.13 10.24z"
    />
    <path
      fill="#fff"
      d="M19.69 26.65l-3.56-3.14h-11a2.77 2.77 0 01-2.64-2.87V8.2A2.74 2.74 0 015.17 5.35H26.74A2.75 2.75 0 0129.37 8.2V20.62a2.76 2.76 0 01-2.63 2.85H23zM4.84 7.75V21.19h12l2.82 2.63 2.54-2.65h4.71V7.75z"
    />
  </svg>
)

interface HlsAudioButtonProps {
  onOpenAudio: () => void
}

/**
 * Dedicated Audio Track button for the HLS.js player control bar.
 * Only rendered when 2+ audio tracks are available.
 * Opens the settings panel directly to the audio sub-page.
 */
export const HlsAudioButton: React.FC<HlsAudioButtonProps> = ({ onOpenAudio }) => {
  const { t } = useTranslate('common')

  return (
    <button
      type="button"
      data-hls-settings-trigger
      className="group relative flex h-9 w-9 items-center justify-center rounded-full transition-colors hover:bg-white/20"
      onClick={onOpenAudio}
      aria-label={t('audioTrack', 'Audio Track')}
    >
      <AudioTracksIcon />
      <HlsTooltip
        title={t('audioTrack', 'Audio Track')}
        subtitle={t('audioTrackDescription', 'Switch audio language.')}
      />
    </button>
  )
}
